/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Account_Email_ExistsInputs */

const en_funnel_account_email_exists = /** @type {(inputs: Funnel_Account_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That email already has an account. Sign in to start your trial on it.`)
};

const es_funnel_account_email_exists = /** @type {(inputs: Funnel_Account_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese correo ya tiene una cuenta. Inicia sesión para empezar tu prueba en ella.`)
};

/**
* | output |
* | --- |
* | "That email already has an account. Sign in to start your trial on it." |
*
* @param {Funnel_Account_Email_ExistsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_account_email_exists = /** @type {((inputs?: Funnel_Account_Email_ExistsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Account_Email_ExistsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_account_email_exists(inputs)
	return en_funnel_account_email_exists(inputs)
});